import { createGlobalStyle } from "styled-components";

import { DEVICE_BREAKPOINTS } from "./layoutBreakpoints";

export const GlobalStyles = createGlobalStyle`
  :root {
    @media (max-width: ${DEVICE_BREAKPOINTS.MD}) {
      && {
        font-size: 16px;
      }
    }
    @media (max-width: ${DEVICE_BREAKPOINTS.XS}) {
      && {
        font-size: 14px;
      }
  }}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Roboto, sans-serif;
    box-sizing: border-box !important;
  }
`;
